import useMutation from "src/hooks/useMutation";

function useBankInfoRemove(id) {
  return useMutation({
    path: `/api/v1/bank-infos/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/bank-infos`,
      shouldRevalidate: true,
    },
  });
}

export default useBankInfoRemove;

